<template>
  <section class="hero is-medium has-background-black-ter" id="Skills">
    <div class="hero-body">
      <h1 class="title has-text-white">
        Skills
      </h1>
      <!-- <h1 class="subtitle" style="color: #6b31d9;">
        What do I like to do?
      </h1> -->

      <div class="container">
        <div class="columns is-4">
          <div class="column skillContainer is-one-quarter">
            <div class="categoryTitle is-5 has-text-grey"><strong style="color: #8354FD;">Development</strong></div>
            <br> <br>
            <div class="rows">
              <div class="columns is-flex-wrap-wrap">
                <div class="columns is-multiline is-mobile">
                  <div class="column is-4" v-for="(icon, index) in iconsDev" :key="index">
                    <div class="boxz">
                      <div class="icon-box">
                        <img :src="icon" alt="Development Icon" class="custom-svg-icon" />
                        <div class="title-box">{{ titlesDev[index] }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column skillContainer is-one-quarter">
            <div class="categoryTitle is-5 has-text-grey"><strong style="color: #7D4EFE;">Designing</strong></div>
            <br> <br>
            <div class="rows">
              <div class="columns is-flex-wrap-wrap">
                <div class="columns is-multiline is-mobile">
                  <div class="column is-4 is-mobile" v-for="(icon, index) in iconsDesign" :key="index">
                    <div class="boxz">
                      <div class="icon-box">
                        <img :src="icon" alt="Design Icon" class="custom-svg-icon" />
                        <div class="title-box">{{ titlesDesign[index] }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column skillContainer is-one-quarter">
            <div class="categoryTitle is-5 has-text-grey"><strong style="color: #8354FD;">3D & Unity</strong></div>
            <br> <br>
            <div class="rows">
              <div class="columns is-flex-wrap-wrap">
                <div class="columns is-multiline is-mobile">
                  <div class="column is-4" v-for="(icon, index) in icons3D" :key="index">
                    <div class="boxz">
                      <div class="icon-box">
                        <img :src="icon" alt="3D & Unity Icon" class="custom-svg-icon" />
                        <div class="title-box">{{ titles3D[index] }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'SkillsComponent',
  setup() {
    const iconsDev = ref([
      require('@/assets/skills/html.svg'),
      require('@/assets/skills/css.svg'),
      require('@/assets/skills/js.svg'),
      require('@/assets/skills/vue.svg'),
      require('@/assets/skills/react.svg'),
      require('@/assets/skills/python.svg'),
      require('@/assets/skills/csharp.svg'),
      require('@/assets/skills/arduino.svg'),
      require('@/assets/skills/github.svg'),
    ]);

    const titlesDev = ref([
      'HTML',
      'CSS',
      'Java Script',
      'Vue',
      'React',
      'Python',
      'C#',
      'Arduino',
      'GitHub',
    ]);

    const iconsDesign = ref([
      require('@/assets/skills/sketch.svg'),
      require('@/assets/skills/ai.svg'),
      require('@/assets/skills/ps.svg'),
      require('@/assets/skills/ae.svg'),
      require('@/assets/skills/xd.svg'),
      require('@/assets/skills/cc.svg'),
      require('@/assets/skills/id.svg'),
    ]);


    const titlesDesign = ref([
      'Sketch',
      'AI',
      'PS',
      'AE',
      'xd',
      'CC',
      'ID',
    ]);

    const icons3D = ref([
      require('@/assets/skills/unity.svg'),
      require('@/assets/skills/blender.svg'),
      require('@/assets/skills/mixamo.svg'),
      require('@/assets/skills/googlevr.svg'),
      require('@/assets/skills/mrtk.svg'),
      require('@/assets/skills/oculusvr.svg'),
    ]);

    const titles3D = ref([
      'Unity',
      'Blender',
      'Mixamo',
      'Google VR',
      'MRTK AR/VR',
      'Oculus VR',
    ]);

    return {
      iconsDev,
      titlesDev,
      iconsDesign,
      titlesDesign,
      icons3D,
      titles3D,
    };
  },
};
</script>



<style>
  .rows {
    display: flex;
    flex-direction: column;
  }

  .subtitle {
    padding-bottom: 2rem;
  }

  .skillContainer {
    margin: auto;
    margin-top: 0;
  }

  .icon-box {
    text-align: center; /* Center the content horizontally */
    font-size: smaller;
    margin-top: 1vw;
  }

  .title-box {
    font-size: 12px;
    font-weight: bold;
    margin-top: 0.5rem;
    text-align: center;
    height: 2vw;
    padding-top: auto;
    color: #7D4EFE;
  }

  .categoryTitle {
    font-size: larger;
  }

  .boxz {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    background-color: #30008A;
    border-radius: 5%;
  }


  @media only screen and (max-width: 1410px) {
    .boxz {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: auto;
      padding-top: 2vw;
      padding-bottom: 1vw;
    }

    .title-box {
      font-size: xx-small;
    }
  }

  @media only screen and (max-width: 850px) {
    
    .boxz {
      padding: 1vw;
    }
  
    .custom-svg-icon {
      width: 2rem; /* Set a fixed width for the icons */
      height: auto; /* Set a fixed height for the icons */
    }

  }

  @media only screen and (max-width: 768px) {
    .categoryTitle {
      margin-top: 10vw;
      margin-bottom: 0;
    }

    .subtitle {
      margin-bottom: -1.25rem;
    }

    .boxz {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: auto;
      padding-top: 5vw;
      padding-bottom: 5vw;
    }
  }

  .custom-svg-icon {
    width: auto; /* Set a fixed width for the icons */
    height: 2rem; /* Set a fixed height for the icons */
    max-width: 100%; /* Ensure the SVG does not exceed the fixed width */
  }

  @media only screen and (max-width: 1410px) {
    .boxz {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: auto;
      padding-top: 2vw;
      padding-bottom: 1vw;
    }

    .title-box {
      font-size: xx-small;
    }
  
    .custom-svg-icon {
    width: auto; /* Set a fixed width for the icons */
    height: 2rem; /* Set a fixed height for the icons */
  }
  
  }

  @media only screen and (max-width: 880px) {
    .boxz {
      padding: auto;
    }

    .custom-svg-icon {
    width: 2vw; /* Set a fixed width for the icons */
    height: auto; /* Set a fixed height for the icons */
  }

  .title-box {
    margin-bottom: 1.8vw;
  }

  }

  @media only screen and (max-width: 768px) {
    .categoryTitle {
      margin-top: 10vw;
      margin-bottom: 0;
    }

    .subtitle {
      margin-bottom: -1.25rem;
    }

    .boxz {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: auto;
      padding-top: 5vw;
      padding-bottom: 5vw;
    }
  
    .custom-svg-icon {
    width: 8vw; /* Set a fixed width for the icons */
    height: auto; /* Set a fixed height for the icons */
  }
  }


</style>
